import { Component, OnInit, OnDestroy, AfterViewInit, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { PostInvoiceList } from '../../../../models/PostInvoiceList';
import { ContractService } from '../../../../services/contract.service';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { NgForm } from '@angular/forms';
import { ConfirmationPageFailComponent } from '../../../../shared-components/confirmation-page-fail/confirmation-page-fail.component';
/*tslint:disable:max-line-length */
import { ConfirmationPageSuccessComponent } from '../../../../shared-components/confirmation-page-success/confirmation-page-success.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { BusyIndicatorComponent } from '../../../../shared-components/busy-indicator/busy-indicator.component';
import { userProfile } from '../../../../models/userProfile';

import { AdminService } from '../../../../services/Admin.service';
import { PostedInvoice } from '../../../../models/PostedInvoice';
import { CreditPayment } from '../../../../models/CreditPayment';
/*tslint:enable:max-line-length */
import { ModalComponent } from '../../../../shared-components/modal/modal.component';
import { EmailService } from '../../../../services/email.service';
import { NegToParnthPipe } from '../../../../pipes/neg-to-parnth.pipe';
import { forEach } from '@angular/router/src/utils/collection';

@Component({
  selector: 'app-pastdueinvoices',
  templateUrl: './pastdueinvoices.component.html',
  styleUrls: ['./pastdueinvoices.component.scss']
})
export class PastdueinvoicesComponent implements OnInit, OnDestroy {

  postedInvoicesList: PostInvoiceList;
  private _router: Router;
  showFailConfirmation: boolean;
  showSuccessConfirmation: boolean;
  user: userProfile;
  invURL: string;

  private alive = true;
  // Email invoice/credit/etc...
  @ViewChild('templateEmail') templateEmail: ModalComponent;
  @ViewChild('templateConfirmation') templateConfirmation: ModalComponent;
  public emailToAddress: string;
  public emailCCAddress: string;
  public emailComments: string;
  public showEmailSuccessConfirmation = false;
  public showEmailFailConfirmation = false;
  public emailSentFailMessage = '';

  selAll: boolean;

  public docNumberToSendEmail: string;
  public doctype: string;

  constructor(private contractsvc: ContractService, private adminService: AdminService, private router: Router,
    private spinner: NgxSpinnerService
    , private emailSvc: EmailService
    , private _spinner: NgxSpinnerService
  ) {
    this._router = router;
  }

  ngOnInit() {
    this.selAll = false;
    this.getPostedInvoices();
    this.getUserProfile();
    // this.getUrl();
  }

  // async getUrl() {
  //     this.invURL = await this.contractsvc.getConfig('InvoiceLink');
  //     console.log(this.invURL);
  //     }
  getPostedInvoices() {
    this.spinner.show();
    this.contractsvc.getPastDueInvoices()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          this.spinner.hide();
          console.log(data);
          this.postedInvoicesList = data;
        },
        err => {
          this.spinner.hide();
          console.log(err);
        }
      );
  }
  getUserProfile() {
    this.adminService.getUserInfo()
      .takeWhile(() => this.alive)
      .subscribe(
        data => {

          console.log(data);
          this.user = data;
        },
        err => {

          console.log(err);
        }
      );
  }
  getInvCount(postedInv: PostedInvoice, postdate: any) {

    const invlist = postedInv.Invoices.filter(inv => inv.DueDate === postdate);

    return invlist.length;
  }
  getcreditCount(postedInv: PostedInvoice, postdate: any) {

    const crdlist = postedInv.Credits.filter(inv => inv.PostDate === postdate);

    return crdlist.length;
  }

  payInvoiceLink(inv: PostedInvoice) {

    this.router.navigateByUrl(`/pages/client/my-contracts/contract/${inv.ContractNumber}/financials?payInvoices=true`);

  }
  selectAll() {
    this.selAll = !this.selAll;
    // console.log('inside select all');

    if (this.postedInvoicesList && this.postedInvoicesList.PostedInvoiceViewList) {
      console.log('inside postedInvoicesList');
      this.postedInvoicesList.PostedInvoiceViewList.forEach(e =>
        e.Invoices.forEach(inv => inv.PayInvoice = this.selAll)
      );
      this.postedInvoicesList.PostedInvoiceViewList.forEach(e =>
        e.Credits.forEach(cre => cre.ApplyCredit = this.selAll));
    }

    // console.log('flag', this.selAll);
    // console.log(this.postedInvoicesList);

  }
  downloadall() {
    this.postedInvoicesList.Search = 'All';
  }
  download() {
    console.log('download');
    //  this.spinner.show();
    // Open window first to prevent ad blocker coming into play
    const loWinExt = window.open();

    loWinExt.document.title = 'Please wait ...';
    this.contractsvc.DownloadpostedInvoices(this.postedInvoicesList)
      .subscribe(
        data => {
          //  this.spinner.hide();
          if (loWinExt) {
            loWinExt.location.href = data;
            loWinExt.document.title = 'Downloaded';
          } else {
            window.open(data, '_blank');
            loWinExt.document.title = 'Downloaded';
          }
        },
        err => {
          //   this.spinner.hide();
          console.log(err);
        }
      );
  }
  getStmtPdfFile( contractNumber: string, stmtType: string) {
    // Open window first to prevent ad blocker coming into play
    const loWinExt = window.open();
    if (stmtType.indexOf('National') <= -1) {
    this.emailSvc.getStmtPdfFile( contractNumber)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          if (loWinExt) {
            loWinExt.location.href =  data;
          } else {
            window.open(data, '_blank');
          }
        },
        err => {
          console.log(err);
        }
      );
      } else {
        this.emailSvc.getAccountStmtPdfFile( contractNumber, stmtType)
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          if (loWinExt) {
            loWinExt.location.href =  data;
          } else {
            window.open(data, '_blank');
          }
        },
        err => {
          console.log(err);
        }
      );
      }

  }

  getPdfFile(invNumber: string, creditNumber: string, contractNumber: string, actionName: string) {
    // Open window first to prevent ad blocker coming into play
    const loWinExt = window.open();

    this.emailSvc.getPdfFile(invNumber, creditNumber, contractNumber, actionName, '')
      .takeWhile(() => this.alive)
      .subscribe(
        data => {
          if (loWinExt) {
            loWinExt.location.href =  data;
          } else {
            window.open(data, '_blank');
          }
        },
        err => {
          console.log(err);
        }
      );
  }


  showEmailModal(docNumber: string, docType: string) {
    this.docNumberToSendEmail = docNumber;
    this.doctype = docType;
    this.templateEmail.show();
  }

  sendEmail(type: string, number: string) {

    this.templateEmail.hide();
    this._spinner.show();

    this.emailSvc.sendEmail(this.docNumberToSendEmail, '', this.emailToAddress, this.emailCCAddress, 'Email', this.emailComments,
    this.doctype)
      .takeWhile(() => this.alive)
      .subscribe(data => {

        console.log(data);

        this._spinner.hide();
        this.showEmailSuccessConfirmation = true;
        this.showEmailFailConfirmation = false;

        this.templateConfirmation.show();
      },
        err => {
          this._spinner.hide();
          console.log('Sending email failed.');
          console.log(err._body);

          this.showEmailSuccessConfirmation = false;
          this.showEmailFailConfirmation = true;
          this.emailSentFailMessage = err._body;

          this.templateConfirmation.show();
        },
        () => console.log('sendEmail Complete')
      );

  }

  getRemaining(emailComments: string, maximum: number): string {
    return `${emailComments ? maximum - emailComments.length : maximum} characters remaining`;
  }

  public ngOnDestroy() {
    this.alive = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/client/my-contracts/pastdueinvoices/pastdueinvoices.component.ts